<template>
  <div class="ma-5">
    <titleAgency />
    <!-- <v-tabs
      v-model="activeTab"
      @change="changeTab()"
      style="margin-top: -48px;"
      background-color="titlebackground"
    >
      <v-tab>อนุมัติคำร้อง</v-tab>
      <v-tab>รับทราบคำร้อง</v-tab>
    </v-tabs> -->
    <filterAgency :mode="page" v-if="render"/>
    <tableAgency :mode="page" v-if="render"/>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import titleAgency from '@/components/_manageapprovetransferrole/_overview/title.vue'
import filterAgency from '@/components/_manageapprovetransferrole/_overview/filter.vue'
import tableAgency from '@/components/_manageapprovetransferrole/_overview/table.vue'
export default {
  components: {
    titleAgency, filterAgency, tableAgency
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true
    }
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
        localStorage.setItem('approveRole', 'Admin')
        EventBus.$emit('updateNavbarRole', 'Admin')
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
        localStorage.setItem('approveRole', 'Leader')
        EventBus.$emit('updateNavbarRole', 'Leader')
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
